export default "<div class=\"container-fluid\">\n  <h4>Admin users</h4>\n</div>\n";